import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($scope, Alert) {
        this.$scope = $scope;
        this.Alert = Alert;
    }

    $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
        let baseURI = document.baseURI;
        this.endpoints = {
            'discovery': `${baseURI}.well-known/openid-configuration`,
            'jwks': `${baseURI}${this.clientId}/.well-known/jwks.json`,
            'authorization': `${baseURI}oauth/authorize`,
            'token': `${baseURI}oauth/token`,
            'userinfo': `${baseURI}oauth/userinfo`,
            'logout': `${baseURI}oauth/logout`,
        }
    }

    getCredentials() {
        this.credentials$.get().then((data) => {
            this.credentials = data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/oidc-endpoints/oidc-endpoints.controller.js